  <template>
  <v-container>
    <v-card>
      <v-card-title>Event Page Views</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="startDate" label="Start Date" type="date" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="endDate" label="End Date" type="date" />
          </v-col>
        </v-row>
        <v-btn color="primary" @click="fetchData" :loading="loading">Search</v-btn>
      </v-card-text>
      <v-card-text>
        <div class="mb-4">
          <span class="font-bold">Total Views:</span> {{ total }}
          <span class="ml-4 font-bold">Unique Visitors:</span> {{ uniqueVisitors }}
        </div>
        <v-data-table :items="data" :headers="headers" :loading="loading">
          <template v-slot:item.visited_at="{ item }">
            {{ formatDateTime(item.visited_at) }}
          </template>
          <template v-slot:item.url="{ item }">
            {{ stripQuery(item.url) }}
          </template>
          <template v-slot:item.referer="{ item }">
            {{ stripQuery(item.referer) }}
          </template>
          <template v-slot:[`item.browser`]="{ item }">
            <span>{{ getBrowser(item.user_agent) }}</span>
          </template>
          <template v-slot:[`item.device`]="{ item }">
            <span>{{ getDevice(item.user_agent) }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

import Layout from '@/Shared/VuetifyAdminLayout';
import { UAParser } from 'ua-parser-js';
export default {
layout: Layout,
  data() {
    return {
      startDate: '',
      endDate: '',
      data: [],
      total: 0,
      uniqueVisitors: 0,
      loading: false,
      headers: [
        { text: 'Time', value: 'visited_at' },
        { text: 'IP Address', value: 'ip_address' },
        { text: 'URL', value: 'url' },
        { text: 'Browser', value: 'browser' }, 
        { text: 'Device', value: 'device' }, 
        { text: 'Referrer', value: 'referer' },
      ],
    };
  },
  methods: {
    getBrowser(userAgent) {
      if (!userAgent) return 'Unknown';
      const parser = new UAParser(userAgent);
      const result = parser.getResult();
      return result.browser.name || 'Unknown';
    },

    getDevice(userAgent) {
      if (!userAgent) return 'Unknown';
      const parser = new UAParser(userAgent);
      const result = parser.getResult();
      const deviceType = result.device.type;

      if (deviceType === 'mobile') {
        return 'Mobile';
      } else if (deviceType === 'tablet') {
        return 'Tablet';
      } else {
        return 'Desktop'; // Or more specific, e.g., result.os.name
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get('/admin/analytics/events-data', {
          params: { startDate: this.startDate, endDate: this.endDate }
        });
        this.data = res.data.data;
        this.total = res.data.total;
        this.uniqueVisitors = res.data.uniqueVisitors;
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      return date.toLocaleString();
    },
    stripQuery(url) {
      if (!url) return '';
      return url.split('?')[0];
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
